const ordenEstudioInitialState = {
    ordenEstudio: {
        loading: false,
        error: null,
        data: null,
        eliminado: null
    },
};

export default ordenEstudioInitialState;